var exports = {
  "a": "Button_0__ITZOI6",
  "J": "Octicon_0__90NAoi",
};

module.exports = exports;
